import actionTypes from "../actions/actionTypes";
import { produce } from "immer";
import {
    parseSeqId,
    isGridRowDeleted,
} from "components/ExtraAttributes/GridEditorControl/GridUtils";

export const initialState = produce({}, () => ({
    detailView: {},
    defaults: {},
    isEditMode: {},
    "ea.tab": {},
}));

const formReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        let isNew, seqId;
        const {
            name,
            seqId: seqIdFromPayload,
            rowIndex,
        } = action.payload || {};
        switch (action.type) {
            case actionTypes.EA_AUDITLOG_UPDATE:
                /* istanbul ignore else */
                if (draft[name] == null) {
                    draft[name] = {};
                }
                /* istanbul ignore else */
                if (draft[name].auditLog == null) {
                    draft[name].auditLog = {};
                }
                /* istanbul ignore else */
                if (draft[name].auditLog.updatedRows == null) {
                    draft[name].auditLog.updatedRows = {};
                }
                /* istanbul ignore else */
                if (
                    draft[name].auditLog.updatedRows[seqIdFromPayload] == null
                ) {
                    draft[name].auditLog.updatedRows[seqIdFromPayload] = [];
                }

                Object.assign(
                    draft[name].auditLog.updatedRows[seqIdFromPayload],
                    action.payload.values
                );
                return draft;

            case actionTypes.EA_AUDITLOG_DEL:
                [isNew, seqId] = parseSeqId(seqIdFromPayload);
                if (isNew) {
                    draft[name]?.auditLog?.newRows?.splice(seqId, 1);
                    return draft;
                }
                if (
                    state[name] &&
                    isGridRowDeleted(state[name].auditLog, seqId)
                ) {
                    return state;
                }
                /* istanbul ignore else */
                if (draft[name] == null) {
                    draft[name] = {};
                }
                /* istanbul ignore else */
                if (draft[name].auditLog == null) {
                    draft[name].auditLog = {};
                }
                /* istanbul ignore else */
                if (draft[name].auditLog.deletedIds == null) {
                    draft[name].auditLog.deletedIds = [];
                }
                draft[name].auditLog.deletedIds.push(seqId);
                return draft;

            case actionTypes.EA_AUDITLOG_INSERT:
                /* istanbul ignore else */
                if (draft[name] == null) {
                    draft[name] = {};
                }
                /* istanbul ignore else */
                if (draft[name].auditLog == null) {
                    draft[name].auditLog = {};
                }
                /* istanbul ignore else */
                if (draft[name].auditLog.newRows == null) {
                    draft[name].auditLog.newRows = [];
                }

                /* istanbul ignore else */
                if (draft[name].auditLog.newRows[rowIndex] == null)
                    draft[name].auditLog.newRows[rowIndex] = [];

                Object.assign(
                    draft[name].auditLog.newRows[rowIndex],
                    action.payload.values
                );
                return draft;

            case actionTypes.EA_AUDITLOG_CLEAR:
                [isNew, seqId] = parseSeqId(seqIdFromPayload);
                if (isNew) {
                    /* istanbul ignore next */
                    if (draft[name] == null)
                        draft[name] = {
                            auditLog: { newRows: [] },
                        };
                    draft[name].auditLog.newRows[seqId] = action.payload.values;
                    return draft;
                }
                // Clear Updates
                if (draft[name] == null) {
                    draft[name] = { auditLog: { updatedRows: {} } };
                } else if (draft[name].auditLog.updatedRows == null) {
                    draft[name].auditLog.updatedRows = {};
                } else {
                    delete draft[name].auditLog.updatedRows[seqIdFromPayload];
                }

                // Clear Deletes
                if (
                    state[name] &&
                    isGridRowDeleted(state[name].auditLog, seqId)
                ) {
                    draft[name].auditLog.deletedIds.splice(
                        state[name].auditLog.deletedIds.indexOf(seqId),
                        1
                    );
                }
                return draft;

            case actionTypes.EA_GRID_CURRENTROW:
                /* istanbul ignore else */
                if (draft[name] == null) draft[name] = {};
                draft[name].rowIndex = rowIndex;
                draft[name].seqId = seqIdFromPayload;
                return draft;

            case actionTypes.EA_DETAILVIEW_SET:
                if (action.payload == null) {
                    draft.detailView = {};
                    return draft;
                } else {
                    /* istanbul ignore else */
                    if (draft.detailView == null) draft.detailView = {};
                    Object.assign(draft.detailView, action.payload);
                    return draft;
                }

            case actionTypes.EA_FIELD_SET:
                if (action.payload == null) {
                    return;
                } else {
                    draft.lastChange = action.payload;
                    return draft;
                }

            case actionTypes.EA_TABINDEX_SET:
                /* istanbul ignore else */
                if (draft["ea.tab"] == null) draft["ea.tab"] = {};
                /* istanbul ignore else */
                if (draft["ea.tab"][action.payload.itemUri] == null)
                    draft["ea.tab"][action.payload.itemUri] = {};
                /* istanbul ignore else */
                if (draft["ea.tab"][action.payload.itemUri][name] == null)
                    draft["ea.tab"][action.payload.itemUri][name] = {};

                draft["ea.tab"][action.payload.itemUri][name].tabIndex =
                    action.payload.tabIndex;
                return draft;

            case actionTypes.EA_CLEAR:
                // make sure not to clear the default form values (set by containers/DefaultValuesHandler)
                draft = {
                    ...initialState,
                    defaults: draft.defaults,
                    isEditMode: draft.isEditMode,
                    "ea.tab": draft["ea.tab"],
                };
                return draft;

            case actionTypes.FORM_DEFAULTS_SET:
                draft = {
                    ...initialState,
                    defaults: action.payload.defaults,
                    isEditMode: draft.isEditMode,
                    "ea.tab": draft["ea.tab"],
                };
                return draft;

            case actionTypes.FORM_EDITMODE_SET:
                // make sure not to clear the default form values (set by containers/DefaultValuesHandler)
                draft = {
                    ...initialState,
                    defaults: draft.defaults,
                    isEditMode: {},
                    "ea.tab": draft["ea.tab"],
                };
                // HACK tricky to get called to pass in viewName, so we set everything here
                if (name === "doc") {
                    draft.isEditMode.docmodal = action.payload.isEditMode;
                    draft.isEditMode.document = action.payload.isEditMode;
                } else if (name === "folder") {
                    draft.isEditMode.folder = action.payload.isEditMode;
                } else {
                    console.error("Unknown form named " + name);
                }
                return draft;

            /* istanbul ignore next */
            case actionTypes.PERSIST_PURGE:
                return initialState;
            default:
                return;
        }
    });

export default formReducer;

export const formDetailViewSelector = (state: Object) => state.form.detailView;
export const formLastChangeSelector = (state: Object) => state.form.lastChange;
export const formAuditLogSelector = (state: Object, name: string) =>
    state.form?.[name]?.auditLog ?? null;
export const formGridRowIndexSelector = (state: Object, name: string) =>
    state.form?.[name]?.rowIndex ?? -1;
export const formGridRowSeqIdSelector = (state: Object, name: string) =>
    state.form?.[name]?.seqId ?? -1;
export const formDefaultsSelector = (state: Object) => state.form.defaults;
export const formIsEditModeSelector = (state: Object, name: string) =>
    state.form?.isEditMode?.[name] ?? false;
export const formTabIndexSelector = (
    state: Object,
    name: string,
    itemUri: string
) => state.form?.["ea.tab"]?.[itemUri]?.[name]?.tabIndex ?? -1;
